import { $FixMe } from '@eventbrite/ts-utils';
import filter from 'lodash/filter';
import find from 'lodash/find';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { trackEnterMapView as trackEnterMapViewAction } from '../../../../redux/actions/analytics';
import { getUserCurrentLocation as getUserCurrentLocationAction } from '../../../../redux/actions/location';
import {
    removeBBoxFromSearchCriteria as removeBBoxFromSearchCriteriaAction,
    searchByBBox as searchByBBoxAction,
    viewEventMapView as viewEventMapViewAction,
} from '../../../../redux/actions/search';
import {
    setMapPinClickTarget as setMapPinClickTargetAction,
    setMapPinHoverTarget as setMapPinHoverTargetAction,
} from '../../../../redux/actions/ui';
import { bboxShape, FeatureFlags } from '../../../../types/index';
import { getSearchContent } from '../../../../utils/general';
import SearchMap from '../../components/SearchMap/index';

const parseResultsForMap = (results: any, isLoading: boolean) => {
    let eventsForSearchMap = [];

    if (!isLoading) {
        eventsForSearchMap = find(results, ({ type }) => type === 'event');
        eventsForSearchMap = get(eventsForSearchMap, 'content');
        eventsForSearchMap = filter(
            eventsForSearchMap,
            ({ latitude, longitude }) => latitude && longitude,
        );
    }

    return eventsForSearchMap;
};

const _mapStateToProps = (
    state: {
        content: { entities: $FixMe };
        pagination: {
            loading: boolean;
            currentPage: number;
            paginationData?: Record<string, $FixMe>;
        };
        currencyFormat?: string;
        app: {
            countryCode: string;
            googleMapsLanguage?: string;
            featureFlags?: FeatureFlags;
            domain: string;
        };
        location: {
            currentPlace?: string;
            currentPlaceParent?: string;
            latitude: number;
            longitude: number;
            userLatLng: GeolocationCoordinates | null;
            isUsingCurrentLocation: boolean;
        };
        auth: { isAuthenticated?: boolean };
        search: { eventSearch: { bbox: bboxShape } };
        googleMapsApiKey?: string;
        ui: {
            focusedEventCards: string[];
        };
    },
    ownProps: {
        height: number;
        hoverEventCardTarget?: React.ReactNode;
        isFixed?: boolean;
        isMobile?: boolean;
        onSaveEvent?: Function;
    },
) => ({
    events: parseResultsForMap(
        getSearchContent(
            state.content.entities,
            state.pagination,
            state.currencyFormat,
        ),
        state.pagination.loading,
    ),
    domain: state.app.domain,
    countryCode: state.app.countryCode,
    googleMapsApiKey: state.googleMapsApiKey,
    googleMapsLanguage: state.app.googleMapsLanguage,
    currentPlace: state.location.currentPlace,
    currentPlaceParent: state.location.currentPlaceParent,
    latitude: state.location.latitude,
    longitude: state.location.longitude,
    isAuthenticated: state.auth.isAuthenticated,
    searchMapBounds: state.search.eventSearch.bbox,
    featureFlags: state.app.featureFlags,
    height: ownProps.height,
    isFixed: ownProps.isFixed,
    hoverEventCardTarget: ownProps.hoverEventCardTarget,
    onSaveEvent: ownProps.onSaveEvent,
    isMobile: ownProps.isMobile,
    isLoading: state.pagination.loading,
    isUsingCurrentLocation: state.location.isUsingCurrentLocation,
    selectedPinEvent: state.ui.focusedEventCards[0] ?? undefined,
    userLatLng: state.location.userLatLng,
});

const _mapDispatchToProps = (
    dispatch: Function,
    ownProps: { history: any },
) => ({
    searchByBBox: (...args: any) =>
        dispatch(searchByBBoxAction(ownProps.history, ...args)),
    removeBBoxFromSearchCriteria: (...args: [$FixMe]) =>
        dispatch(removeBBoxFromSearchCriteriaAction(...args)),
    enterMapView: () => dispatch(trackEnterMapViewAction()),
    viewEventMapView: (...args: [$FixMe]) =>
        dispatch(viewEventMapViewAction(...args)),
    setMapPinHoverTarget: (eventIds: string[]) =>
        dispatch(setMapPinHoverTargetAction(eventIds)),
    setMapPinClickTarget: (eventIds: string[]) =>
        dispatch(setMapPinClickTargetAction(eventIds)),
    handleUseCurrentLocation: () =>
        dispatch(getUserCurrentLocationAction(ownProps.history, false, true)),
});

export const MapContainer = withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SearchMap),
) as $FixMe;
